import { CSSProperties } from "react"
import cx from "classnames"
import "./FormSectionRow.css"

const FormSectionRow = ({ children, style, className = "" }: { children: JSX.Element[] | JSX.Element | (JSX.Element | boolean)[] | boolean, style?: CSSProperties, className?: string }) => {
    return <div className={cx("venta-habitacion__form-section__row",  className)} style={style}>{children}</div>
}

export default FormSectionRow
